export default __webpack_public_path__ + "static/media/drag_drop.dfc3cfff.svg";